import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { GLOBAL_ACTION_KEYS, ROOT_REDUCER_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceServicePrincipalsGetPrefix = 'WorkspaceServicePrincipalsGet';
const workspaceServicePrincipalsGetEpicReducerArg = {
    actionPrefix: workspaceServicePrincipalsGetPrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.GLOBAL,
        GLOBAL_ACTION_KEYS.GET_SP,
    ],
    loadResource: (request) => {
        return WPSResource.getWorkspaceServicePrincipals(request.workspaceId, request.identityType);
    },
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceServicePrincipalsGetEpicReducer = loadResourcesUtils(workspaceServicePrincipalsGetEpicReducerArg);

//# sourceMappingURL=GetWorkspaceServicePrincipals.ducks.js.map
